import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import * as sitesApi from './../../api/sites-api';
import SiteForm from './SiteForm';
import SiteDefaultsForm from './SiteDefaultsForm';
import Status from '../utils/Status';
import * as blockUtils from './../../utils/BlockUtils';
import * as rights from './../../model/rights';
import * as viewUtils from './../../utils/view-utils';
import * as siteModel from './../../model/site';
import TableAction from './../utils/actions/TableAction';
import ShowAction from './../utils/actions/ShowAction';
import EditAction from './../utils/actions/EditAction';
import EditDefaultsAction from './../utils/actions/EditDefaultsAction';
import DestroyAction from './../utils/actions/DestroyAction';
import TableActions from './../utils/TableActions';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import AnalyticsOptionsForm from './AnalyticsOptionsForm';
import WkcCardForm from './WkcCardForm';
import SiteAuditForm from '../audit/SiteAuditForm';
import MaxAllowedDevicesForm from './MaxAllowedDevicesForm';
import SiteManagementForm from './SiteManagementForm';
import PopoverBtn from '../utils/PopoverBtn';
import ReactDOMServer from 'react-dom/server';
import UserAccessList from '../utils/users/UserAccessList';
import store from '../../store';
import * as actions from '../../actions/checkins-actions';

class SitesList extends Component {
  constructor(props) {
    super(props);

    this.userManagementFormDialogId = 'userManagementFormDialogId';
    this.siteFormDialogId = 'siteFormDialog';
    this.siteHistoryDialogId = 'siteHistoryDialogId';

    this.destroySite = this.destroySite.bind(this);
    this.disableSite = this.disableSite.bind(this);
    this.enableSite = this.enableSite.bind(this);
    this.showSiteForm = this.showSiteForm.bind(this);
    this.showSiteDefaultsForm = this.showSiteDefaultsForm.bind(this);
    this.showUserManagementForm = this.showUserManagementForm.bind(this);
    this.findCorrectUserSiteAccessEntry = this.findCorrectUserSiteAccessEntry.bind(this);

    this.state = {
      userSiteAccess: [],
    };
  }

  componentDidMount() {
    blockUtils.blockUI('#sites_table');
    sitesApi.getUserOverviewForSiteAccess().then((response) => {
      blockUtils.unblockUI('#sites_table');
      this.setState({userSiteAccess: response.data});
    }).catch(() => {
      blockUtils.unblockUI('#sites_table');
    });
  }

  destroySite(siteId) {
    blockUtils.blockUI('#sites_table');
    sitesApi.destroySite(siteId).then((response) => {
      if (response.status !== 200) {
        window.showAlert(i18next.t('error'), response.statusText);
      }

      blockUtils.unblockUI('#sites_table');
    });
  }

  disableSite(site) {
    this.changeSiteState(site, true);
  }

  enableSite(site) {
    this.changeSiteState(site, false);
  }

  changeSiteState(site, disabled) {
    confirm(
        () => {
          blockUtils.blockUI('#sites_table');
          const siteCopy = siteModel.toForm(site);
          siteCopy.disabled = disabled;
          sitesApi.updateSite(siteCopy).then((response) => {
            blockUtils.unblockUI('#sites_table');

            if (response.status !== 200) {
              window.showAlert(i18next.t('error'), response.statusText);
            }
          });
        },
      disabled ?
        i18next.t('sites.actions.sure_disable') :
        i18next.t('sites.actions.sure_enable'),
    );
  }

  componentDidUpdate() {
    this.handleError();
  }

  handleError() {
    if (this.props.createSiteError) {
      if (this.modalDialog) {
        this.modalDialog.handleError(this.props.createSiteError);
      }
      blockUtils.unblockUI();
    } else {
      $(`#${this.siteFormDialogId}`).modal('hide');
    }
  }

  showSiteForm(site) {
    this.modalProps = {
      dialogId: this.siteFormDialogId,
      error: this.props.createSiteError,
      presentedSite: site,
      user: this.props.user,
      getData: this.props.getData,
    };
    this.modalDialog = viewUtils.showModal(
        SiteForm,
        this.siteFormDialogId,
        this.modalProps,
    );
    store.dispatch(actions.flipDoNotDisturbMode());
  }

  showUserManagementForm(site) {
    this.modalProps = {
      dialogId: this.userManagementFormDialogId,
      site: site,
    };
    this.modalDialog = viewUtils.showModal(
        SiteManagementForm,
        this.userManagementFormDialogId,
        this.modalProps,
    );
  }

  showAnalyticsOptionsForm(siteId) {
    const properties = {
      dialogId: 'analytics-form',
      siteId: siteId,
    };

    viewUtils.showModal(AnalyticsOptionsForm, properties.dialogId, properties);
  }

  showWkcForm(siteId) {
    const properties = {
      dialogId: 'wkc-form',
      siteId: siteId,
    };

    viewUtils.showModal(WkcCardForm, properties.dialogId, properties);
  }

  showMaxAllowedDevicesForm(siteId) {
    const properties = {
      dialogId: 'max-allowed-devices-form',
      siteId: siteId,
    };

    viewUtils.showModal(MaxAllowedDevicesForm, properties.dialogId, properties);
  }

  showSiteDefaultsForm(site) {
    this.modalProps = {
      dialogId: this.siteFormDialogId,
      error: this.props.createSiteError,
      presentedSite: site,
    };
    this.modalDialog = viewUtils.showModal(
        SiteDefaultsForm,
        this.siteFormDialogId,
        this.modalProps,
    );
    store.dispatch(actions.flipDoNotDisturbMode());
  }

  showSiteHistoryForm(siteId) {
    const modalProps = {
      siteId: siteId,
      dialogId: this.siteHistoryDialogId,
      totalElements: 0,
      totalPages: 0,
      records: [],
    };
    this.modalDialog = viewUtils.showModal(
        SiteAuditForm,
        this.siteHistoryDialogId,
        modalProps,
    );
  }

  findCorrectUserSiteAccessEntry(siteId) {
    return this.state.userSiteAccess.find((userSiteAccess) => userSiteAccess.siteId === siteId);
  }

  render() {
    return (
      <div className="table-container">
        <ReduxDataTable
          {...this.props}
          showCreateButton={rights.currentUserHasRight(rights.SITE_ADD_PRIVILEGE)}
          createRecordCallback={this.showSiteForm}
          notSortable={[5, 6, 7]}
        >
          <thead>
            <tr role="row" className="heading">
              <th>ID</th>
              <th>{i18next.t('sites.table_headers.name')}</th>
              <th>{i18next.t('sites.table_headers.status')}</th>
              <th>{i18next.t('sites.table_headers.technology')}</th>
              <th>{i18next.t('sites.table_headers.users')}</th>
              <th>{i18next.t('sites.table_headers.hms_version')}</th>
              <th>{i18next.t('sites.table_headers.last_connected')}</th>
              <th>{i18next.t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.sites.map((site) => {
              return (
                <tr key={site.id} className="odd">
                  <td>{site.id}</td>
                  <td>{site.name}</td>

                  {/* Site Agent status */}
                  <td className="status-column">
                    <Status online={site.connected}/>
                  </td>

                  {/* Technology Type */}
                  <td className="status-column">
                    <span>{site.appTechnology}</span>
                  </td>

                  <td>
                    {this.findCorrectUserSiteAccessEntry(site.id) ?
                      (<PopoverBtn
                        viewClass='btn btn-xs'
                        popoverContent={ReactDOMServer.renderToStaticMarkup(<UserAccessList userNames={this.findCorrectUserSiteAccessEntry(site.id).userNames}/>)}
                        title={`${i18next.t('users.name_plural', {count: 2})}: ${this.findCorrectUserSiteAccessEntry(site.id).userNames.length}`}
                      />) :

                      <button className="btn btn-xs popover_btn">
                        {`${i18next.t('users.name_plural', {count: 2})}: 0`}
                      </button>
                    }
                  </td>
                  <td>{site.siteAgentVersion}</td>
                  <td>
                    {site.connected ? i18next.t('sites.online') : site.lastSeen}
                  </td>
                  <td style={{textAlign: 'center'}}>
                    <TableActions identifier={site.id}>
                      <ShowAction
                        title={i18next.t('sites.actions.show_specialareas')}
                        icon="icon-lock"
                        path={`/sites/${site.id}/specialareas`}
                        condition={rights.currentUserHasRight(rights.SPECIAL_AREA_READ_PRIVILEGE)}
                      />
                      <EditAction
                        onEdit={() => this.showSiteForm(site)}
                        condition={rights.currentUserHasRight(rights.SITE_EDIT_PRIVILEGE)}
                      />
                      <EditDefaultsAction
                        onEdit={() => this.showSiteDefaultsForm(site)}
                        condition={rights.currentUserHasRight(rights.SITE_EDIT_PRIVILEGE)}
                      />
                      <TableAction
                        text={i18next.t('sites.actions.show_history')}
                        action={() => this.showSiteHistoryForm(site.id)}
                        icon="icon-info"
                      />
                      <TableAction
                        text={i18next.t('sites.actions.user_management')}
                        action={() => this.showUserManagementForm(site)}
                        icon="icon-user"
                      />
                      <TableAction
                        text={i18next.t('terminals.edit_analytics_options_title')}
                        action={() => this.showAnalyticsOptionsForm(site.id)}
                        condition={rights.currentUserHasRight(rights.SITE_EDIT_PRIVILEGE)}
                        icon="icon-pie-chart"
                      />
                      <TableAction
                        text={i18next.t('site_management.wkc_card.menu')}
                        action={() => this.showWkcForm(site.id)}
                        condition={rights.currentUserHasRight(rights.SITE_ASSIGN_WKC_PRIVILEGE)}
                        icon="icon-pie-chart"
                      />
                      <TableAction
                        text={i18next.t('site_management.max_allowed_devices.maxAllowedDevices')}
                        action={() => this.showMaxAllowedDevicesForm(site.id)}
                        condition={rights.currentUserHasRight(rights.MAX_ALLOWED_DEVICES_READ_PRIVILEGE)}
                        icon="icon-pie-chart"
                      />
                      <TableAction
                        text={i18next.t('sites.actions.enable')}
                        action={() => this.enableSite(site)}
                        condition={site.disabled === true && rights.currentUserHasRight(rights.SITE_DISABLE_PRIVILEGE)}
                        icon="icon-check"
                      />
                      <TableAction
                        text={i18next.t('sites.actions.disable')}
                        action={() => this.disableSite(site)}
                        condition={site.disabled !== true && rights.currentUserHasRight(rights.SITE_DISABLE_PRIVILEGE)}
                        icon="icon-ban"
                      />
                      <DestroyAction
                        destroyElement={() => this.destroySite(site.id)}
                        condition={rights.currentUserHasRight(rights.SITE_DELETE_PRIVILEGE)}
                      />
                    </TableActions>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ReduxDataTable>
      </div>
    );
  }
}

SitesList.propTypes = {
  sites: PropTypes.array,
  createSiteError: PropTypes.object,
  getSitesError: PropTypes.string,
  destroySiteError: PropTypes.string,
  user: PropTypes.object,
  userSiteAccess: PropTypes.array,
  getData: PropTypes.func,
};

SitesList.defaultProps = {};

export default SitesList;
